import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "#WebcampLj was bitchin'",
  "description": "",
  "published": "2011-10-23T00:00:00.000Z",
  "redirect_from": ["/blog/webcamplj-was-bitchin/swizec/2696"],
  "categories": "Ljubljana, Online Communities, Slovenia, Social Networking, Twitter, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Yesterday was Webcamp time again and the creme de la creme of the `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=46.05,14.5&spn=10.0,10.0&q=46.05,14.5%20(Slovenia)&t=h",
        "title": "Slovenia"
      }}>{`Slovenia`}</a>{` web scene gathered to bang chests and feel awesome.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/tumblr_ltgywtGhCz1qekjngo1_500.jpg",
        "alt": null,
        "title": "Freedom Box"
      }}></img></p>
    <p>{`Or ... well ... a bunch of geeks who had nothing better to do on a Saturday.`}</p>
    <p>{`There were a bunch of great talks by some marvelous people and I especially liked that there were once more `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Lightning_Talk",
        "title": "Lightning Talk"
      }}>{`lightning talks`}</a>{` to finish the day off. Can't remember when was the last time we managed to have those ... actually, I think the last time might have been the original two Barcamps that set off the meme of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Unconference",
        "title": "Unconference"
      }}>{`unconferences`}</a>{` in `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=46.0555555556,14.5083333333&spn=0.1,0.1&q=46.0555555556,14.5083333333%20(Ljubljana)&t=h",
        "title": "Ljubljana"
      }}>{`Ljubljana`}</a>{`.`}</p>
    <p>{`If I can say that it's a meme since to my knowledge they're organized by the one and only `}<a parentName="p" {...{
        "href": "http://twitter.com/gandalfar"
      }}>{`@gandalfar`}</a>{`. That guy could make 20 people show up to watch paint dry!`}</p>
    <p>{`There were two talks that really stuck in my mind. `}<a parentName="p" {...{
        "href": "http://twitter.com/jamesvasile"
      }}>{`@jamesvasile`}</a>{` talking about Freedom Box and `}<a parentName="p" {...{
        "href": "http://twitter.com/andraz"
      }}>{`@andraz`}</a>{` talking about ... something. I think the point of his talk was mostly that nontechnical founders should prove themselves before pestering technical people to do the heavy lifting and conversely that technical people should be much much more averse to doing heavy lifting and should try their best to reuse whatever crap they can find online.`}</p>
    <p>{`Really I think he was just talking about what everybody is talking these days, but wrapping it up in shiny pictures and his cool way of presenting stuff.`}</p>
    <p>{`The Freedom Box by `}<a parentName="p" {...{
        "href": "http://twitter.com/andraz"
      }}>{`@jamesvasile`}</a>{` was a much more groundbreaking concept. It's this box thingy that hooks up between your internets provider and the main router for the hosue and automagically makes sure all the data oozing out of your every port is encrypted and somewhat secure.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/tumblr_ltgwa8Y4Ka1qekjngo1_5001.jpg",
        "alt": null,
        "title": "Angry Birds reception desk"
      }}></img></p>
    <p>{`An even more interesting concept is that of making self signed certificates trustworthy by embedding a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Public-key_cryptography",
        "title": "Public-key cryptography"
      }}>{`public key`}</a>{` that can be looked up and your identity confirmed ... then there was something about splitting up your key between a lot of friends so each individual doesn't have enough info to attack you, but together they can still stage an intervention ... didn't quite understand that bit.`}</p>
    <p>{`Oh and apparently there's this new python CMS called `}<a parentName="p" {...{
        "href": "http://plone.org/",
        "title": "Plone (software)"
      }}>{`Plone`}</a>{` that isn't in fact new, but does happen to be used by a lot of the big players that need high security and awesomeness. Can't remember the twitter handle of whomever was presenting this, sorry.`}</p>
    <p>{`I also want to say that as far as my end is concerned, my talk about `}<em parentName="p">{`Tools that get you laid `}</em>{`(express.js, backbone.js, underscore.js and ejs and ejs) went quite well. For some reason all the seats in the room were full ... I think people expected something far more interesting to happen than me talking about the technical crap I use to build pet projects.`}</p>
    <p>{`If anyone's interested, here are the hastily assembled super boring slides with no pictures from my talk:`}</p>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "http://www.slideshare.net/Swizec/tools-that-get-you-laid",
          "title": "Tools that get you laid"
        }}>{`Tools that get you laid`}</a></strong></p>
    <p>{`View more `}<a parentName="p" {...{
        "href": "http://www.slideshare.net/"
      }}>{`presentations`}</a>{` from `}<a parentName="p" {...{
        "href": "http://www.slideshare.net/Swizec"
      }}>{`Swizec Teller`}</a></p>
    <p>{`See you all next time!`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=3fe5ffb7-72c0-4b15-bdca-6444671c5283",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      